import { render, staticRenderFns } from "./FileUpload.vue?vue&type=template&id=3254e7c2&"
import script from "./FileUpload.js?vue&type=script&lang=js&"
export * from "./FileUpload.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports